import React from 'react';
import OnboardingWizard from '../components/Onboarding/OnboardingWizard';

/**
 * OnboardingContainer - Simple container component that renders the OnboardingWizard
 * This avoids ReactOnRails trying to use hooks directly during component registration
 */
class OnboardingContainer extends React.Component {
  render() {
    return (
      <OnboardingWizard {...this.props} />
    );
  }
}

export default OnboardingContainer; 